<template>
  <div>
    <div class="row">
      <b-form-group
        id="input-topic-type"
        :label="$t('training-view.topicType')"
        label-for="topic-type"
        label-align="left"
        class="col-2"
      >
        <b-select
        id="topic-type"
        v-model="eval.type" 
        :options="topicTypes"
        @change="changeSessions">
        >
        </b-select>
      </b-form-group>
      <b-form-group
        id="input-training-session"
        :label="$t('training-view.session')"
        label-for="input-session"
        label-align="left"
        class="col-4"
      >
        <v-select
          v-if="availableSessions != null"
          :options="availableSessions"
          placeholder=""
          label="title"
          :clearable='false'
          v-model="eval.session"
          class="bg-white rounded"
        >
          <template #no-options="{ }">
            {{ $t("training-view.noSessions") }}
          </template>
        </v-select>
      </b-form-group>
      <label v-if="totalParticipants != null && evalParticipants != null" class="col-4 my-auto"><b-icon icon="info-circle"></b-icon> {{ $t('training-view.haveEvaluated', { needed: totalParticipants , done: evalParticipants })}} </label>
      <div class="col-2">
        <b-button variant="primary" class="esep-blue-bg col-lg-9 col-sm-12 mt-4 float-right" @click="calculateEvaluation()" :disabled="!eval.session.id">
          {{ $t("training-view.calculate")}}</b-button>
      </div>
    </div>
    <hr />
    <b-table 
      :items="evaluationItems"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyEvalTotalTable") }}</h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import { handleApiError } from "../../services/error.service";

export default {
  props: {
    activity:  Object,
    sessions: Array    
  },
  mounted() {
    this.getActivitysSessionsEvaluation();
    this.getActivitysEvaluationParticipants();
    this.sessions.forEach(actSession => {
      if(actSession.session.type == 'LESSON') {
        this.availableLessons.push(actSession.session);
      } else {
        this.availableActions.push(actSession.session);
      }
    });
    this.$log.debug(this.sessions);
    this.$log.debug(this.availableLessons);
    this.availableSessions = this.availableLessons;
  },
  data() {
    return {
      eval: {
        session: {
          id: null
        },
        type: 'LESSON'
      },
      topicTypes: [
        { value: 'LESSON', text: this.$t('training-view.LESSON') },
        { value: 'ACTION', text: this.$t('training-view.ACTION') },
      ],
      availableSessions: null,
      availableLessons: [],
      availableActions: [],
      fields: [
        { key: "criteria.title", label: "Κριτήριο Αξιολόγησης", sortable: false, class: 'text-left'},
        { key: "activitySession", label: "Εκπαιδευτής", sortable: false, formatter: 'formatFullName', class: 'text-left' },
        { key: "evaluationValue", label: "Βαθμός", sortable: false }
      ],
      evaluationItems: [],
      evalParticipants: null,
      totalParticipants: null,
      sortBy: 'trainer',
      sortDesc: true
    }
  },
  methods: {
    // calculateEvaluation() {
    //
    // },
    changeSessions(type) {
      if(type == 'LESSON') {
        this.availableSessions = this.availableLessons;
        this.eval.session = {id: null}
      } else {
        this.availableSessions = this.availableActions;
        this.eval.session = {id: null}
      }
    },
    getEvaluation(){
      trainingService.getSessionsEvaluation(this.eval.session.id, this.activity.id).then(
        (response) => {
          this.$log.debug('evaluationByCriteria')
          this.$log.debug(response.data);
          let evalItems = [];
          response.data.forEach(evalItem => {
            let item = {criteria: evalItem.criteria, trainer: evalItem.activitySession.trainer, evaluationValue: evalItem.evaluationValue}
            evalItems.push(item);
          });
          this.evaluationItems = evalItems;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getActivitysSessionsEvaluation() {
       trainingService.getActivitysSessionsEvaluation(this.activity.id).then(
        (response) => {
          this.$log.debug("evaluation")
          this.$log.debug(response.data)
          // this.average = response.data.result;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getActivitysEvaluationParticipants() {
      trainingService.getActivitysEvaluationParticipants(this.activity.id).then(
        (response) => {
          this.evalParticipants = response.data.evalParticipants;
          this.totalParticipants = response.data.totalParticipants;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getSessionsCriteria(sessionId) {
      trainingService.getSessionsCriteria(sessionId).then(
        (response) => {
          this.$log.debug('criteria');
          this.$log.debug(response.data)
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    calculateEvaluation() {
      trainingService.calculateActivitySessionsEvaluation(this.activity.id, this.eval.session.id).then(
          (response) => {
            this.evaluationItems = response.data;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      )
    },
    formatFullName(session) {
      return session.trainer? session.trainer?.surName +" " + session.trainer?.firstName: session.associateName;
    }
  }
}
</script>